import React, { useEffect } from 'react';
import { styled } from '@mui/system';

const FormContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  border-radius: 8px;
`;

const FormWrapper = styled('div')`
  max-width: 600px;
  width: 100%;
  background-color: #fff;
  padding: 1rem;
  border-radius: 8px;
`;

const FormTitle = styled('h4')`
  margin-bottom: 1rem;
  font-size: 1.5rem;
  text-align: center;
`;

const FormDescription = styled('p')`
  margin-bottom: 2rem;
  font-size: 1rem;
  text-align: justify;
`;

const FormField = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
`;

const FormInput = styled('input')`
  flex: 1;
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
`;

const SubmitButton = styled('button')`
  flex: 1;
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  color: #fff;
  background-color: #fda4af;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-sizing: border-box;

  &:hover {
    background-color: #fb7185;
  }
`;

const SuccessMessage = styled('div')`
  display: none;
  text-align: center;
  color: #28a745;
  margin-top: 1rem;
`;

const MailerLiteForm = () => {
  useEffect(() => {
    window.ml_webform_success_custom = function (response) {
      const formEl = document.getElementById('mailer-form');
      const successEl = document.getElementById('mailer-success');
      if (formEl && successEl) {
        formEl.style.display = 'none';
        successEl.style.display = 'block';
      }
    };

    return () => {
      delete window.ml_webform_success_custom;
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);
    const queryParams = new URLSearchParams();

    for (const [key, value] of data.entries()) {
      queryParams.append(key, value);
    }

    const url = `https://assets.mailerlite.com/jsonp/1295993/forms/144430731472406434/subscribe?${queryParams.toString()}&callback=ml_webform_success_custom`;

    const script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);

    setTimeout(() => {
      document.body.removeChild(script);
    }, 5000);
  };

  return (
    <FormContainer>
      <FormWrapper>
        <FormTitle>Dołącz do Newslettera</FormTitle>
        <FormDescription>
          Otrzymuj ekskluzywne informacje o aplikacji, jej aktualizacjach i praktyczne wskazówki! Nie przegap żadnej nowości – zapisz się już teraz!
        </FormDescription>
        <form id="mailer-form" onSubmit={handleSubmit}>
          <FormField>
            <FormInput
              aria-label="email"
              aria-required="true"
              type="email"
              name="fields[email]"
              placeholder="Email"
              autoComplete="email"
              required
            />
          </FormField>
          <FormField>
            <SubmitButton type="submit">Zapisz</SubmitButton>
          </FormField>
          <input type="hidden" name="ml-submit" value="1" />
          <input type="hidden" name="anticsrf" value="true" />
        </form>
        <SuccessMessage id="mailer-success" className="ml-form-successBody row-success">
          <h4>Dziękujemy!</h4>
          <p>Zapisanie do naszej listy zakończone sukcesem :)</p>
        </SuccessMessage>
      </FormWrapper>
    </FormContainer>
  );
};

export default MailerLiteForm;
